import React from "react";
import { Send } from "lucide-react";
import { useData } from "../data/DataContext";
import { Corners } from "./Hero";

const TelegramBanner = () => {
  const { telegramLink: TELEGRAM_LINK } = useData();
  if (!TELEGRAM_LINK) return null;
  return (
    <div className="max-w-4xl mx-auto px-4 my-8">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 group relative bg-[#073c1b] border-2 border-dashed border-[#1c5f35] rounded-2xl px-6 py-5">
        <Corners inside size="w-6 h-6" color="border-[#ffb224]" />
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-full bg-[#ffb224] flex items-center justify-center shadow-lg animate-pulse">
            <Send size={20} className="text-[#062a13]" />
          </span>
          <div>
            <p className="font-extrabold text-white">Join Our Telegram Channel</p>
            <p className="text-xs text-emerald-50/65 font-medium">Daily new apps, promo codes & bonus alerts</p>
          </div>
        </div>
        <a
          href={TELEGRAM_LINK}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-2 bg-[#ffb224] hover:bg-[#ffc14d] text-[#062a13] font-extrabold px-6 py-2.5 rounded-xl border-b-[4px] border-[#b47400] active:border-b-0 active:translate-y-[4px] transition-colors duration-200"
        >
          <Send size={16} /> Join Now
        </a>
      </div>
    </div>
  );
};

export default TelegramBanner;
